export interface TokenStorage {
  getToken(): string | null
  setToken(token: string): void
  clear(): void
  getUsername(): string | null
  setUsername(username: string): void
}

export interface AppEnv {
  apiBaseUrl: string
  isProduction: boolean
  encryptionKey: string
  awsBaseUrl?: string
  /** Sent as `X-Client-Platform`; the API only hands realtime config to `ios`/`android`. */
  clientPlatform?: string
}

export interface AuthNavigator {
  goToAuth(): void
}

export type ToastSeverity = 'success' | 'error' | 'info' | 'warning'

export interface UiFeedback {
  showToast(message: string, severity?: ToastSeverity): void
  setLoadingMessage(message: string): void
  clearLoading(): void
  closeDialog(): void
}

export type PlatformConfig = {
  storage: TokenStorage
  env: AppEnv
  navigator: AuthNavigator
  feedback: UiFeedback
}

let platform: PlatformConfig | null = null

export function configurePlatform(config: PlatformConfig) {
  platform = config
}

export function getPlatform(): PlatformConfig {
  if (!platform) {
    throw new Error(
      '@gusiberi/shared: call configurePlatform() before using Auth, API, or feedback helpers'
    )
  }
  return platform
}

export function getStorage(): TokenStorage {
  return getPlatform().storage
}

export function getEnv(): AppEnv {
  return getPlatform().env
}

export function getNavigator(): AuthNavigator {
  return getPlatform().navigator
}

export function getFeedback(): UiFeedback {
  return getPlatform().feedback
}
